import React from 'react'
import {Typography} from 'antd'
import {CliInstallContent} from '../Profile/CliInstallTab'

const {Title} = Typography

// 独立安装页（/cli-install）与个人中心「安装 CLI」tab 共用同一份内容，
// 避免两处安装命令/版本说明久了对不上。
export default function CliInstall() {
    return (
        <div style={{maxWidth: 880, margin: '0 auto', padding: '32px 24px'}}>
            <Title level={3} style={{marginTop: 0}}>乐纯 CLI</Title>
            <CliInstallContent />
        </div>
    )
}
